import { VBadge } from 'vuetify/lib/components/VBadge';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{name: 'purchasingCart'}}},[_c(VBadge,{staticStyle:{"cursor":"pointer"},attrs:{"content":_vm.purchaseRequestItemTotal,"value":_vm.purchaseRequestItemTotal,"overlap":""}},[_c(VIcon,{attrs:{"large":""}},[_vm._v("mdi-cart")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }